// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles_btn__1eetx","icon":"styles_icon__7PWPj","title":"styles_title__3ezCV"};